export default __webpack_public_path__ + "static/color-3-edaee959967eb387dafe4efb0e12cfb0.png";